import { Navigate, Outlet } from 'react-router';
import { usePermissions } from '../../hooks/use-permissions';
import { isGuardQuerySettling } from './guard-query-state';

/**
 * Gates the /admin tree on the real platform-admin flag (User.isPlatformAdmin),
 * NOT on the tenant-scoped "Admin" role name. This closes the SEC-05 collision
 * on the frontend: the backend PlatformAdminGuard already checks isPlatformAdmin,
 * so the client gate must use the same signal. See CLAUDE.md → Subscription Policy.
 */
export function PlatformAdminGuard() {
  const { isPlatformAdmin, isPending, fetchStatus } = usePermissions();
  if (isGuardQuerySettling({ isPending, fetchStatus })) {
    return null;
  }
  if (!isPlatformAdmin) {
    return <Navigate to="/home" replace />;
  }
  return <Outlet />;
}
